module.exports = __webpack_public_path__ + "static/media/signage-indoor-img9.c7a00158.jpg";